import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { useQuestionStore } from '../../store/useQuestionStore';

export default function StartGameWrapper(props) {
  const questionStore = useQuestionStore()
  const currentState = questionStore.questionState['0']
  console.log("currentState1", currentState);

  const isStarted = currentState.started
  const [isGameStarted, setIsGameStarted] = useState(false);
  return <>{!isStarted ? <>

    <div style={{
      position: 'relative'
    }}>
      <div style={{ filter: 'blur(8px)', opacity: 0.2 }}>
        {props.children}
      </div>
      <Button style={{ position: 'absolute', top: '40%', left: '30%' }} type={'button'}
        variant={'contained'}
        onClick={() => questionStore.updateStartState('0', true)}>
        Start {props.questionType}</Button>
    </div>

  </> : <>{props.children}</>}</>
}